import { render, staticRenderFns } from "./package_mipaquete.vue?vue&type=template&id=0f176109&scoped=true"
import script from "./package_mipaquete.vue?vue&type=script&lang=js"
export * from "./package_mipaquete.vue?vue&type=script&lang=js"
import style0 from "./package_mipaquete.vue?vue&type=style&index=0&id=0f176109&prod&scoped=true&lang=css"
import style1 from "./package_mipaquete.vue?vue&type=style&index=1&id=0f176109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f176109",
  null
  
)

export default component.exports